const landing_page = {
  aboutUs: "Sobre nós", // translated
  topPackages: "Principais pacotes", // translated
  featuredHotels: "Hotéis em destaque", // translated
  topTours: "Principais passeios", // translated
  whatOurMembersSay: "O que nossos membros dizem...", // translated
  followUsOnInstagram: "Siga-nos no Instagram", // translated
  pleaseWait: "Por favor, espere...", // translated
  packages: "Pacotes", // translated
  learnMore: "Saber mais", // translated
  ourPartners: "Nossos parceiros", // translated
  trustedCarHirePartners: "Parceiros confiáveis de aluguel de carros", // translated
};

export default landing_page;
